import { SectionTypeEnum } from '@ulysses-inc/harami_api_client'
import type {
  SectionNode,
  SectionNodeBase,
  SectionType,
} from '~/domain/report/model/report/node/sectionNode/sectionNode'
import type { ReportSection } from '@ulysses-inc/harami_api_client'

/**
 * 表セクションに関するセクション種別。
 */
export type TableSectionType = Extract<
  SectionType,
  'table' | 'tableRowMaster' | 'tableRowInstance' | 'tableRowFixed'
>

/**
 * API スキーマのセクションから、表セクションの種別を導出する。
 * 表セクションと無関係のセクションの場合は undefined を返す。
 *
 * 行セクションの種別は以下のように導出する:
 * - originalNodeUuid あり → tableRowInstance（記録中に追加された行）
 * - isRepeat = 1 かつ originalNodeUuid なし → tableRowMaster（テンプレート行）
 * - それ以外（isRepeat = 0）→ tableRowFixed（固定行）
 */
export const convertToTableSectionType = (
  reportSection: ReportSection,
): TableSectionType | undefined => {
  if (reportSection.sectionType === SectionTypeEnum.Table) {
    return 'table'
  }
  if (reportSection.sectionType !== SectionTypeEnum.TableRow) {
    return undefined
  }
  if (reportSection.originalNodeUuid) {
    return 'tableRowInstance'
  }
  if (reportSection.isRepeat) {
    return 'tableRowMaster'
  }
  return 'tableRowFixed'
}

/**
 * API スキーマのセクションから、表セクションのノードを生成する。
 */
export const convertTableSection = (
  sectionBase: SectionNodeBase,
  reportSection: ReportSection,
  tableSectionType: TableSectionType,
  getMasterNodeId: (
    sectionNodeId: number,
    reportSection: ReportSection,
  ) => number,
): SectionNode => {
  switch (tableSectionType) {
    case 'table':
      return {
        ...sectionBase,
        section: {
          name: sectionBase.section.name,
          sectionType: 'table',
        },
      }
    case 'tableRowMaster':
      return {
        ...sectionBase,
        section: {
          name: sectionBase.section.name,
          sectionType: 'tableRowMaster',
        },
      }
    case 'tableRowFixed':
      return {
        ...sectionBase,
        section: {
          name: sectionBase.section.name,
          sectionType: 'tableRowFixed',
        },
      }
    case 'tableRowInstance':
      return {
        ...sectionBase,
        section: {
          name: sectionBase.section.name,
          sectionType: 'tableRowInstance',
          masterNodeId: getMasterNodeId(sectionBase.id, reportSection),
        },
      }
  }
}
